<template>
  <div class="free-sample-select-wrapper">
    <select
      v-if="freeSamplesPresent"
      class="free-sample-select form-control"
      aria-label="Select a Free Sample"
      @change="change"
    >
      <option v-if="!selectedSampleId">Please Select a Free Sample</option>
      <option
        v-for="(freeSample, index) in freeSamples"
        :key="index"
        :selected="freeSample.id === selectedSampleId"
        :value="freeSample.id"
      >
        {{ freeSample.name }}
      </option>
    </select>
    <div v-if="!freeSamplesPresent" class="message">
      We are unable to offer a free fragrance sample with your order due to a
      temporary stock shortage. We apologize for the inconvenience and hope to
      provide the sample promotion again soon.
    </div>
  </div>
</template>

<script>
  import axios from "axios"

  export default {
    props: {
      selectedSampleId: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        freeSamples: [
          {
            name: "Please wait...",
          },
        ],
      }
    },
    computed: {
      freeSamplesPresent() {
        return this.freeSamples.length > 0
      },
    },
    created() {
      axios.get("/cs/api/free_samples").then((response) => {
        this.freeSamples = response.data.free_samples
      })
    },
    methods: {
      change(event) {
        const variantId = event.target.value
        this.$emit("change", variantId)
        event.target.blur()
      },
    },
  }
</script>
